import { AsyncPipe } from '@angular/common'
import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { AppComponentBase } from '@framework/app.component.base'
import { MemberHeaderComponent } from '@framework/components/member/header/header.component'
import { FooterComponent } from '@framework/modules/ui/components/footer/footer.component'
import { IconDefinitionsComponent } from '@framework/modules/ui/components/icon/icon-definitions/icon-definitions.component'
import { ScrollBlockUiService } from '@framework/services/scroll-block-ui.service'

@Component({
  selector: 'alpha-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [ScrollBlockUiService],
  imports: [MemberHeaderComponent, RouterOutlet, IconDefinitionsComponent, FooterComponent, AsyncPipe],
})
export class AppComponent extends AppComponentBase {}
